import React from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'

export const MinusIcon = (props: SvgProps) => (
  <svg
    height="20"
    width="20"
    fill="none"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>{props?.title}</title>
    <path
      d="M15.8333 9.16675C16.2936 9.16675 16.6667 9.53984 16.6667 10.0001C16.6667 10.4603 16.2936 10.8334 15.8333 10.8334H4.16668C3.70644 10.8334 3.33334 10.4603 3.33334 10.0001C3.33334 9.53984 3.70644 9.16675 4.16668 9.16675H15.8333Z"
      fill="#474A53"
    />
  </svg>
)
